export enum TournamentTypeEnum {
  League = "LEAGUE",
  Knockout = "KNOCK_OUT",
  Hybrid = "HYBRID",
}
